import { useEffect } from "react";

import * as ScrollPositionService from "@/services/scrollPosition.service";

export const SaveScrollPosition = () => {
    const handleBeforeUnload = () => {
        ScrollPositionService.pushPosition(
            window.scrollY,
            window.location.href
        );
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    return null;
};
